import * as React from 'react';
import * as _ from 'lodash';
import BlogPost from '../../BlogPosts/BlogPost/_lazy';
import LazyWrapper from '../../../generic/LazyWrapper';
export default function () {
    function repeatBlogPost1(blogPosts, blogPost, blogPostIndex) {
        return React.createElement(BlogPost, _.assign({}, {
            'key': blogPostIndex,
            'showSocial': true
        }, blogPost));
    }
    function scopeBlogPosts2() {
        var blogPosts = this.getBlogPosts();
        return React.createElement('div', { 'id': 'RelatedBlogPosts' }, blogPosts.length ? React.createElement('h2', { 'key': '239' }, 'Related Posts') : null, React.createElement(LazyWrapper, {}, React.createElement.apply(this, [
            'div',
            { 'className': 'blog-posts-content' },
            _.map(blogPosts, repeatBlogPost1.bind(this, blogPosts))
        ])));
    }
    return scopeBlogPosts2.apply(this, []);
}